export default {
  name: 'PcTableRow',
  data() {
    return {
      className: 'app__table__row',
    };
  },
  props: {
    type: {
      type: String,
      default: 'body',
    },
  },
  computed: {
    headerClassName() {
      return this.type === 'header' ? `${this.className}__header` : '';
    },
  },
};
